/**
 * GeoLog 미디어 스크림 다크 톤 — `rgb(${GEOLOG_SCRIM_RGB})` / `rgba(${GEOLOG_SCRIM_RGB}, alpha)`
 * 채널로 쓰는 RGB 트리플릿.
 *
 * CSS 색 문자열이 **아니다**(`"26, 29, 36"`) — `color`·`backgroundColor` 에 그대로 넣으면
 * 무효값이 되므로 반드시 `rgb()`/`rgba()` 안에 보간해서 쓴다.
 */
export const GEOLOG_SCRIM_RGB = "26, 29, 36";
